import { useLocale } from 'framework/locales/useLocale'
let isFirstLoad = true
export function useInitLocale() {
  const init = async () => {
    if (!isFirstLoad) return
    const { changeLocale, getLocale } = useLocale()

    const defaultLocal = await import(`../../locales/${getLocale.value}.ts`)

    changeLocale(getLocale.value, defaultLocal?.default)
    isFirstLoad = false
  }
  return {
    init,
  }
}
